 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import LOVE_1 from '@/components/love_1'
 import OEBPSTEXTPRAISE_FOR_WARREN_EASLEY from '@/components/OEBPS/Text/Praise_for_Warren_Easley'
 import OEBPSTEXTTITLE_PAGE from '@/components/OEBPS/Text/Title_Page'
 import OEBPSTEXTCOPYRIGHT from '@/components/OEBPS/Text/Copyright'
 import OEBPSTEXTCONTENTS from '@/components/OEBPS/Text/Contents'
 import OEBPSTEXTDEDICATION from '@/components/OEBPS/Text/Dedication'
 import OEBPSTEXTEPIGRAPHS from '@/components/OEBPS/Text/Epigraphs'
 import OEBPSTEXTACKNOWLEDGMENTS from '@/components/OEBPS/Text/Acknowledgments'
 import OEBPSTEXTCHAPTER_1 from '@/components/OEBPS/Text/Chapter_1'
 import OEBPSTEXTCHAPTER_2 from '@/components/OEBPS/Text/Chapter_2'
 import OEBPSTEXTCHAPTER_3 from '@/components/OEBPS/Text/Chapter_3'
 import OEBPSTEXTCHAPTER_4 from '@/components/OEBPS/Text/Chapter_4'
 import OEBPSTEXTCHAPTER_5 from '@/components/OEBPS/Text/Chapter_5'
 import OEBPSTEXTCHAPTER_6 from '@/components/OEBPS/Text/Chapter_6'
 import OEBPSTEXTCHAPTER_7 from '@/components/OEBPS/Text/Chapter_7'
 import OEBPSTEXTCHAPTER_8 from '@/components/OEBPS/Text/Chapter_8'
 import OEBPSTEXTCHAPTER_9 from '@/components/OEBPS/Text/Chapter_9'
 import OEBPSTEXTCHAPTER_10 from '@/components/OEBPS/Text/Chapter_10'
 import OEBPSTEXTCHAPTER_11 from '@/components/OEBPS/Text/Chapter_11'
 import OEBPSTEXTCHAPTER_12 from '@/components/OEBPS/Text/Chapter_12'
 import OEBPSTEXTCHAPTER_13 from '@/components/OEBPS/Text/Chapter_13'
 import OEBPSTEXTCHAPTER_14 from '@/components/OEBPS/Text/Chapter_14'
 import OEBPSTEXTCHAPTER_15 from '@/components/OEBPS/Text/Chapter_15'
 import OEBPSTEXTCHAPTER_16 from '@/components/OEBPS/Text/Chapter_16'
 import OEBPSTEXTCHAPTER_17 from '@/components/OEBPS/Text/Chapter_17'
 import OEBPSTEXTCHAPTER_18 from '@/components/OEBPS/Text/Chapter_18'
 import OEBPSTEXTCHAPTER_19 from '@/components/OEBPS/Text/Chapter_19'
 import OEBPSTEXTCHAPTER_20 from '@/components/OEBPS/Text/Chapter_20'
 import OEBPSTEXTCHAPTER_21 from '@/components/OEBPS/Text/Chapter_21'
 import OEBPSTEXTCHAPTER_22 from '@/components/OEBPS/Text/Chapter_22'
 import OEBPSTEXTCHAPTER_23 from '@/components/OEBPS/Text/Chapter_23'
 import OEBPSTEXTCHAPTER_24 from '@/components/OEBPS/Text/Chapter_24'
 import OEBPSTEXTCHAPTER_25 from '@/components/OEBPS/Text/Chapter_25'
 import OEBPSTEXTCHAPTER_26 from '@/components/OEBPS/Text/Chapter_26'
 import OEBPSTEXTCHAPTER_27 from '@/components/OEBPS/Text/Chapter_27'
 import OEBPSTEXTCHAPTER_28 from '@/components/OEBPS/Text/Chapter_28'
 import OEBPSTEXTCHAPTER_29 from '@/components/OEBPS/Text/Chapter_29'
 import OEBPSTEXTCHAPTER_30 from '@/components/OEBPS/Text/Chapter_30'
 import OEBPSTEXTCHAPTER_31 from '@/components/OEBPS/Text/Chapter_31'
 import OEBPSTEXTCHAPTER_32 from '@/components/OEBPS/Text/Chapter_32'
 import OEBPSTEXTCHAPTER_33 from '@/components/OEBPS/Text/Chapter_33'
 import OEBPSTEXTCHAPTER_34 from '@/components/OEBPS/Text/Chapter_34'
 import OEBPSTEXTCHAPTER_35 from '@/components/OEBPS/Text/Chapter_35'
 import OEBPSTEXTCHAPTER_36 from '@/components/OEBPS/Text/Chapter_36'
 import OEBPSTEXTCHAPTER_37 from '@/components/OEBPS/Text/Chapter_37'
 import OEBPSTEXTCHAPTER_38 from '@/components/OEBPS/Text/Chapter_38'
 import OEBPSTEXTCHAPTER_39 from '@/components/OEBPS/Text/Chapter_39'
 import OEBPSTEXTCHAPTER_40 from '@/components/OEBPS/Text/Chapter_40'
 import OEBPSTEXTCHAPTER_41 from '@/components/OEBPS/Text/Chapter_41'
 import OEBPSTEXTCHAPTER_42 from '@/components/OEBPS/Text/Chapter_42'
 import OEBPSTEXTCHAPTER_43 from '@/components/OEBPS/Text/Chapter_43'
 import OEBPSTEXTCHAPTER_44 from '@/components/OEBPS/Text/Chapter_44'
 import OEBPSTEXTCHAPTER_45 from '@/components/OEBPS/Text/Chapter_45'
 import OEBPSTEXTCHAPTER_46 from '@/components/OEBPS/Text/Chapter_46'
 import OEBPSTEXTCHAPTER_47 from '@/components/OEBPS/Text/Chapter_47'
 import OEBPSTEXTCHAPTER_48 from '@/components/OEBPS/Text/Chapter_48'
 import OEBPSTEXTEPILOGUE from '@/components/OEBPS/Text/Epilogue'
 import LOVE_2 from '@/components/love_2'
 import OEBPSTEXTMORE_FROM_THIS_AUTHOR from '@/components/OEBPS/Text/More_from_this_Author'
 import OEBPSTEXTCONTACT_US from '@/components/OEBPS/Text/Contact_Us'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/Text/Contents",
 			"name" : "OEBPS/Text/Contents",
 			"component" : OEBPSTEXTCONTENTS
 		},
 		{
 			"path" : "/OEBPS/Text/Dedication",
 			"name" : "OEBPS/Text/Dedication",
 			"component" : OEBPSTEXTDEDICATION
 		},
 		{
 			"path" : "/OEBPS/Text/Epigraphs",
 			"name" : "OEBPS/Text/Epigraphs",
 			"component" : OEBPSTEXTEPIGRAPHS
 		},
 		{
 			"path" : "/OEBPS/Text/Acknowledgments",
 			"name" : "OEBPS/Text/Acknowledgments",
 			"component" : OEBPSTEXTACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/OEBPS/Text/Chapter_1",
 			"name" : "OEBPS/Text/Chapter_1",
 			"component" : OEBPSTEXTCHAPTER_1
 		},
 		{
 			"path" : "/OEBPS/Text/Chapter_2",
 			"name" : "OEBPS/Text/Chapter_2",
 			"component" : OEBPSTEXTCHAPTER_2
 		},
 		{
 			"path" : "/OEBPS/Text/Chapter_3",
 			"name" : "OEBPS/Text/Chapter_3",
 			"component" : OEBPSTEXTCHAPTER_3
 		},
 		{
 			"path" : "/OEBPS/Text/Chapter_4",
 			"name" : "OEBPS/Text/Chapter_4",
 			"component" : OEBPSTEXTCHAPTER_4
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js